export default (errorCode) => {
    return errorCode.indexOf("ERROR_DUPLICATE_EMAIL") !== -1 || errorCode.indexOf("account with the given email already exists") !== -1;
}
